const selectStyles = {
  control: (base, state) => ({
    ...base,
    background: 'var(--bg-input)',
    borderColor: state.isFocused ? 'var(--accent-blue)' : 'var(--border-color)',
    boxShadow: 'none',
    borderRadius: '8px',
    padding: '2px',
    minHeight: '36px',
    '&:hover': { borderColor: 'var(--accent-blue)' },
  }),
  menu: (base) => ({
    ...base,
    background: 'var(--bg-modal)',
    border: '1px solid var(--border-color)',
    borderRadius: '8px',
    overflow: 'hidden',
    zIndex: 9999,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  option: (base, state) => ({
    ...base,
    background: state.isFocused ? 'var(--bg-card-hover)' : 'transparent',
    color: 'var(--text-primary)',
    cursor: 'pointer',
    fontSize: '0.85rem',
    '&:active': { background: 'var(--bg-card)' },
  }),
  multiValue: (base) => ({
    ...base,
    background: 'var(--alpha-blue-15)',
    borderRadius: '6px',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: 'var(--accent-blue)',
    fontSize: '0.82rem',
    fontWeight: 500,
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: 'var(--accent-blue)',
    '&:hover': { background: 'var(--alpha-blue-30)', color: 'white' },
  }),
  singleValue: (base) => ({ ...base, color: 'var(--text-primary)', fontSize: '0.85rem' }),
  input: (base) => ({ ...base, color: 'var(--text-primary)' }),
  placeholder: (base) => ({ ...base, color: 'var(--text-muted)', fontSize: '0.85rem' }),
};

export default selectStyles;
